import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { InputTextArea, Label } from './index'
import { ErrorWrapper, Error } from '../Errors'

const TextArea = ({
  name,
  label,
  placeholder,
  onChange,
  onBlur,
  errors,
  errorMessage,
  defaultValue,
  maxLength,
  ...props
}) => (
  <Fragment>
    <Label>{label}</Label>
    <InputTextArea
      name={name}
      value={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      errors={errors}
      maxLength={maxLength}
      {...props}
    />
    {errors && (
      <ErrorWrapper>
        <Error color="red">{errorMessage}</Error>
      </ErrorWrapper>
    )}
  </Fragment>
)

TextArea.propTypes = {
  defaultValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  errors: PropTypes.bool,
  errorMessage: PropTypes.string,
}

TextArea.defaultProps = {
  maxLength: null,
  errors: false,
  defaultValue: '',
  errorMessage: '',
  onBlur: () => {},
}

export default TextArea
